import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export function StageNodeFields({ localNodeData, updateNodeData, totalStages = 1 }) {
  const safeTotal = Math.max(1, Number(totalStages) || 1);
  const value = Number(localNodeData.stage) || 1;

  return (
    <Box sx={{ mt: 2 }}>
      <FormControl fullWidth>
        <InputLabel id="stage-select-label">Etapa</InputLabel>
        <Select
          variant="outlined"
          labelId="stage-select-label"
          value={value}
          label="Etapa"
          onChange={(e) => updateNodeData('stage', Number(e.target.value))}
        >
          {Array.from({ length: safeTotal }).map((_, idx) => {
            const stageNumber = idx + 1;
            return (
              <MenuItem key={stageNumber} value={stageNumber}>
                {stageNumber}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
}
